import React from 'react';
import { useNavigate } from 'react-router-dom';
import { BoardCardComponent } from './BoardCard.component';
import { Board } from '@/types';

interface BoardCardProps {
  board: Board;
}

export const BoardCard: React.FC<BoardCardProps> = ({ board }) => {
  const navigate = useNavigate();

  const handleCardClick = () => {
    navigate(`/board/${board.name}`);
  };

  const handleOwnerClick = () => {
    navigate(`/user/${board.ownerUsername}`);
  };

  return (
    <BoardCardComponent
      board={board}
      onCardClick={handleCardClick}
      onOwnerClick={handleOwnerClick}
    />
  );
};

